import React, { useState } from "react";
import { getAppId, getEmail } from "../../utility/Common";
import { createNotification } from "../Popup";
import {
  applicationManagementMasilingi,
  url,
} from "../../utility/services/apiService";
import { useNavigate } from "react-router-dom";

const UploadBirthA = ({ status, refreshTable }) => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [showView, setShowView] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [error, setError] = useState(null);
  const [isValidFile, setIsValidFile] = useState(false);
  const [uploadFile, setUploadFile] = useState({});
  const [base64File, setBase64File] = useState("");
  const [uploadResponse, setUploadResponse] = useState("");
  const [fileType, setFileType] = useState("");
  const [documentName, setDocumentName] = useState();
  const [attachmentType, setAttachmentType] = useState();

  const handleClose = () => {
    setError(null);
    setShow(false);
    setShowView(false);
  };
  const handleShow = (data) => {
    setDocumentName(data?.AttachmentName);
    setAttachmentType(data?.AttachmentType);
    setError(null);
    setShow(true);
  };

  const handleShowView = (data) => {
    setDocumentName(data?.AttachmentName);
    setAttachmentType(data?.AttachmentType);
    setError(null);
    viewAttachment(data);
  };
  const viewAttachment = (data) => {
    const payload = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "AttachmentByID",
      DocTypeId: data?.AttachmentID,
      AttachmentID: data?.AttachmentID,
      File: "",
      Type: "",
    };
    applicationManagementMasilingi(payload, "add-attachment-info")
      .then((result) => {
        setIsloading(false);
        if (result.code === 1) {
          setShowView(true);
        }
        if (result.code == 3) {
          navigate("/");
          const info = { type: "error", message: result.message };
          createNotification(info)();
          sessionStorage.clear();
          localStorage.clear();
        }
      })
      .catch(() => {
        setIsloading(false);
      });
  };

  const fileSelectedHandlerImage = (e) => {
    setError(null);
    setUploadFile({});
    setBase64File("");
    const file = e.target.files[0];
    console.log("Selected file:", file); // Debugging log
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      setFileType(file.type);
      setIsValidFile(false);
      setUploadFile({});
      setError("Only image files is allowed");
      createNotification({
        type: "error",
        message: "Only image files is allowed",
      })();
      return;
    }

    if (file.size > 300 * 1024) {
      setIsValidFile(false);
      setUploadFile({});
      setError("File size must be less than 300KB");
      createNotification({
        type: "error",
        message: "File size must be less than 300KB",
      })();
      return;
    }
    setError(null);
    setIsValidFile(false); // Set to false initially until validation passes

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result.split(",")[1];

      // Validate if image is not corrupted by trying to load it
      const img = new Image();
      img.onload = () => {
        // Image loaded successfully - not corrupted
        setFileType(file.type);
        setIsValidFile(true);
        setUploadFile(file);
        setBase64File(base64String);
      };

      img.onerror = () => {
        // Image is corrupted, malformed, or damaged
        setIsValidFile(false);
        setUploadFile({});
        setBase64File("");
        setError(
          "Picha imeharibika au haijulikani. Tafadhali chagua picha nyingine.",
        );
        createNotification({
          type: "error",
          message:
            "Picha imeharibika au haijulikani. Tafadhali chagua picha nyingine.",
        })();
      };

      img.src = reader.result;
    };

    reader.onerror = () => {
      // File reading error
      setIsValidFile(false);
      setUploadFile({});
      setBase64File("");
      setError("Kuna hitilafu katika kusoma faili. Tafadhali jaribu tena.");
      createNotification({
        type: "error",
        message: "Kuna hitilafu katika kusoma faili. Tafadhali jaribu tena.",
      })();
    };

    reader.readAsDataURL(file);
  };

  const fileSelectedHandlerPDF = (e) => {
    setError(null);
    setUploadFile({});
    setBase64File("");
    const file = e.target.files[0];
    console.log("Selected file:", file); // Debugging log
    if (!file) return;
    if (file.type !== "application/pdf") {
      setIsValidFile(false);
      setUploadFile({});
      setError("Only PDF files is allowed");
      createNotification({
        type: "error",
        message: "Only PDF files is allowed",
      })();
      return;
    }

    if (file.size > 500 * 1024) {
      setIsValidFile(false);
      setUploadFile({});
      setError("File size must be less than 300KB");
      createNotification({
        type: "error",
        message: "File size must be less than 500KB",
      })();
      return;
    }

    setIsValidFile(false); // Set to false initially until validation passes

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result.split(",")[1];

      // Validate PDF by checking if it starts with PDF header
      try {
        const binaryString = atob(base64String);
        const pdfHeader = binaryString.substring(0, 5);

        if (pdfHeader === "%PDF-") {
          // Valid PDF file
          setFileType(file.type);
          setIsValidFile(true);
          setUploadFile(file);
          setBase64File(base64String);
        } else {
          // Invalid or corrupted PDF
          setIsValidFile(false);
          setUploadFile({});
          setBase64File("");
          setError(
            "Faili la PDF limeharibika au si halali. Tafadhali chagua faili lingine.",
          );
          createNotification({
            type: "error",
            message:
              "Faili la PDF limeharibika au si halali. Tafadhali chagua faili lingine.",
          })();
        }
      } catch (error) {
        // Error decoding - file is corrupted
        setIsValidFile(false);
        setUploadFile({});
        setBase64File("");
        setError(
          "Faili limeharibika na haliwezi kusomwa. Tafadhali chagua faili lingine.",
        );
        createNotification({
          type: "error",
          message:
            "Faili limeharibika na haliwezi kusomwa. Tafadhali chagua faili lingine.",
        })();
      }
    };

    reader.onerror = () => {
      // File reading error
      setIsValidFile(false);
      setUploadFile({});
      setBase64File("");
      setError("Kuna hitilafu katika kusoma faili. Tafadhali jaribu tena.");
      createNotification({
        type: "error",
        message: "Kuna hitilafu katika kusoma faili. Tafadhali jaribu tena.",
      })();
    };

    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    setIsloading(true);
    e.preventDefault();
    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "Insert",
      DocTypeId: status?.AttachmentType,
      File: base64File,
      Type: uploadFile.type,
    };
    applicationManagementMasilingi(formData, "add-attachment-info")
      .then((result) => {
        console.log("Upload result:", result.code); // Debugging log
        setIsloading(false);
        if (result.code === 1) {
          refreshTable();
          const info = { type: "success", message: result.message };
          createNotification(info)();
          handleClose();
        } else {
          const info = { type: "error", message: result.message };
          createNotification(info)();
        }
      })
      .then(() => {
        setIsloading(false);
        setUploadResponse(`Tayari`);
        handleClose();
      })
      .catch(() => {
        setIsloading(false);
        setUploadResponse(`Bado pakia tena`);
      });
  };

  return (
    <>
      {status?.AttachmentID !== null ? (
        <>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button
            className="btn btn-primary"
            onClick={() => handleShow(status)}
          >
            <text>Hariri</text>
          </button>
          <button
            className="btn btn-success"
            onClick={() => handleShowView(status)}
            style={{ marginLeft: "5px" }}
          >
            <text className="text-white">Angalia</text>
          </button>
        </>
      ) : (
        <>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button className="btn btn-warning" onClick={handleShow}>
            <text className="text-white">Pakia</text>
          </button>
        </>
      )}
      <div
        className={`modal ${show ? "show" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{ display: show ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-scrollable" role="document">
          <div className="modal-content">
            <div
              className="modal-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 15px",
              }}
            >
              <h5 className="modal-title">{documentName?.toUpperCase()}</h5>
              <button
                type="button"
                className="close"
                onClick={handleClose}
                aria-label="Close"
                style={{ marginLeft: "auto" }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {status?.AttachmentType == 1 ? (
                <>
                  <div className="form-group mb-3">
                    {/* <label htmlFor="image-upload" className="custom-file-label">
                      Bonyeza hapa kuchagua Picha ya mwombaji
                    </label> */}
                    <input
                      id="image-upload"
                      type="file"
                      onChange={fileSelectedHandlerImage}
                      accept={"image/png, image/jpeg"}
                      required
                      className="form-control"
                      // style={{ display: "none" }}
                    />
                  </div>
                  <div className="preview mt-3 text-center">
                    {base64File && (
                      <img
                        src={`data:${fileType};base64,${base64File}`}
                        alt="Preview"
                        style={{
                          width: "30%",
                          // height: auto,
                          border: "1px solid #ddd",
                        }}
                      />
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div className="form-group mb-3">
                    {/* <label htmlFor="pdf-upload" className="custom-file-label">
                      Bonyeza hapa kuchagua Viambata vya mwombaji
                    </label> */}
                    <input
                      id="pdf-upload"
                      type="file"
                      onChange={fileSelectedHandlerPDF}
                      accept={"application/pdf"}
                      required
                      className="form-control"
                      // style={{ display: "none" }}
                    />
                  </div>
                  <div className="preview mt-3 text-center">
                    {base64File && (
                      <embed
                        src={`data:application/pdf;base64,${base64File}`}
                        type="application/pdf"
                        style={{
                          width: "100%",
                          height: "300px",
                          border: "1px solid #ddd",
                        }}
                      />
                    )}
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn"
                style={{ background: "#0d47a1", color: "white" }}
                onClick={handleSubmit}
                disabled={!isValidFile || isLoading}
              >
                {isLoading ? "Subiri.." : "HIfadhi"}
              </button>
              <button
                type="button"
                className="btn"
                style={{ background: "#ff4444", color: "white" }}
                onClick={handleClose}
              >
                Funga
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal ${showView ? "showView" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{ display: showView ? "block" : "none" }}
      >
        <div
          className="modal-dialog modal-dialog-scrollable"
          role="document"
          style={{ maxWidth: "80%", width: "70%" }}
        >
          <div className="modal-content">
            <div
              className="modal-header"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "10px 15px",
                position: "relative",
              }}
            >
              <h5 className="modal-title">{`ANGALIA ${documentName?.toUpperCase()}`}</h5>
              <button
                type="button"
                className="close"
                onClick={handleClose}
                aria-label="Close"
                style={{
                  position: "absolute",
                  right: "15px",
                  top: "10px",
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div
              className="modal-body"
              style={{
                textAlign: "center",
                right: "15px",
                top: "10px",
              }}
            >
              {status?.AttachmentPath ? (
                status?.AttachmentPath?.endsWith(".pdf") ? (
                  <embed
                    src={`${url}get_file?path=${status.AttachmentPath}`}
                    width="100%"
                    height="300px"
                    type="application/pdf"
                  />
                ) : (
                  <img
                    src={`${url}get_file?path=${status.AttachmentPath}`}
                    width="130px"
                    alt="Applicant"
                  />
                )
              ) : (
                <p>No file available</p>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn"
                style={{ background: "#ff4444", color: "white" }}
                onClick={handleClose}
              >
                Funga
              </button>
            </div>
          </div>
        </div>
      </div>
      <style>
        {`
          .custom-file-label {
          display: inline-block;
          padding: 1px 15px;
          cursor: pointer;
          background-color:rgb(104, 177, 255);
          color: white;
          border: none;
          border-radius: 4px;
          font-size: 14px;
          text-align: center;
        }

        .custom-file-label:hover {
          background-color:rgb(67, 90, 115);
        }
        `}
      </style>
    </>
  );
};

export default UploadBirthA;
